export const ROLES = {
  Guest: "Guest",
  Employee: "Employee",
  Manager: "Manager",
  Admin: "Admin",
  Owner: "Owner",
};
